module.exports = __webpack_public_path__ + "static/media/36-1.00940014.mp3";